import React, {useState} from "react";
import { FileUpload, LargeButton, MainBody, PageTitle } from "components/core";
import { SideNav } from "components";
import { WidthLimiter } from "./styles";
import http from "services/httpService";
import useNavigateInsuranceSetup from "hooks/useNavigateInsuranceSetup";
import UploadFile from "components/UploadFile";
import GmcPlanSetup from "components/PlanSetup/GmcPlanSetup";
import {OverlayLoader} from "components/core";
import axios from "axios";
import config from'../../config.json'

const GmcRateChart = () => {
    const [file, setFile] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [fileDetail, setFileDetail] = useState();
    const [fileError, setFileError] = useState(false);
    // const userplanId = JSON.parse(localStorage.getItem("userplan_ids"))[0]
    const { navigateInsurancePlan } = useNavigateInsuranceSetup();
    const gmcPostData = JSON.parse(localStorage.getItem('GmcPlanSetup'));

    const handleSumbit = async ()=> {
        if(!file){
            const returnValue = await GmcPlanSetup(gmcPostData, setIsLoading)
            localStorage.setItem('gmc_done', 'TPA')
            navigateInsurancePlan();
            return
        }
        
        localStorage.setItem('gmc_done', 'TPA')
        navigateInsurancePlan();
        let formData = new FormData()
        formData.append('file_details', file)
        formData.append('file_type', 'premiums_excel')
    
        try {
            const { data } = await axios({

              url: config.apiUrl + '/insurance/upload_document/',
              method: 'POST',
              data: formData,
              headers: {
                  Accept: 'application/json',
                  'Content-Type': 'multipart/form-data',
              }

            })
            gmcPostData.premium_id = data.id
            const returnValue = await GmcPlanSetup(gmcPostData, setIsLoading)
            localStorage.setItem('gmc_done', 'TPA')
             navigateInsurancePlan();
        } catch(e){
            alert('Something went wrong.')
        }
        // const rateChartData = new FormData();
        // rateChartData.append("file_details", file);
        // rateChartData.append("gmc_type", "annual");
        // // rateChartData.append("user_plan_id", userplanId);

        // const options = {
        // "Content-Type": "multipart/form-data",
        // };

        // try{
        //     const { data } = await http.post(
        //     "/insurance/setup_gmc_premiums/",
        //     rateChartData,
        //     options
        //     );
        //     localStorage.setItem('gmc_done', 'TPA')
        //     navigateInsurancePlan();
        // }
        // catch(ex){
        //     alert('Something went wrong.')
        // }
    }
    return (
        <>
        {
            isLoading? <OverlayLoader/> :
           <> 
           <SideNav/>
            <MainBody>
                <WidthLimiter>
                <PageTitle title="Setup Group Health Insurance"/>
                    <FileUpload
                        label="Upload Rate Chart"
                        text="Upload File"
                        onSelect={setFile}
                        showError={fileError}
                        bottom="-5rem"
                        />
                        <LargeButton
                            type="submit"
                            label="Save & Next"
                            marginTop="2rem"
                            onClick={handleSumbit}
                        />
                </WidthLimiter>
            </MainBody>
            </>}
        </>
    )
}
export default GmcRateChart